// extracted by mini-css-extract-plugin
export default {"ClientWrapper":"ProvidersList_ClientWrapper__LBu3m","ClientEditWrapper":"ProvidersList_ClientEditWrapper__2p+uF","EmptyState":"ProvidersList_EmptyState__-Kf5s"};